export default __webpack_public_path__ + "static/media/Grand-House.d00e7bff.jpg";